import { render, staticRenderFns } from "./CrudButton.vue?vue&type=template&id=b2cdb408&scoped=true"
import script from "./CrudButton.vue?vue&type=script&lang=js"
export * from "./CrudButton.vue?vue&type=script&lang=js"
import style0 from "./CrudButton.vue?vue&type=style&index=0&id=b2cdb408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cdb408",
  null
  
)

export default component.exports